import { lazyRouteComponent } from "@tanstack/react-router";


type FAQ = { q: string; a: string };
type FAQGroup = { title: string; items: FAQ[] };

export const groups: FAQGroup[] = [
  {
    title: "Om serveringstillstånd",
    items: [
      {
        q: "Vad är ett serveringstillstånd?",
        a: "Ett serveringstillstånd är ett tillstånd från kommunen som ger en verksamhet rätt att servera alkoholdrycker (öl, vin, spritdrycker och andra jästa alkoholdrycker) mot betalning. Tillståndet regleras av alkohollagen (2010:1622) och kräver att både personer och lokal uppfyller lagens krav.",
      },
      {
        q: "Vad är skillnaden mellan serveringstillstånd och alkoholtillstånd?",
        a: "Det är samma sak i praktiken. \"Alkoholtillstånd\" är vardagsspråk – det formella begreppet i alkohollagen är serveringstillstånd. Båda används om tillståndet att servera alkohol på t.ex. restaurang, bar eller vid evenemang.",
      },
      {
        q: "Vad är utskänkningstillstånd?",
        a: "Utskänkningstillstånd är ett äldre uttryck för serveringstillstånd. Begreppet används fortfarande i tal men i lagstiftningen heter det serveringstillstånd.",
      },
      {
        q: "När krävs serveringstillstånd?",
        a: "Serveringstillstånd krävs så fort du säljer eller serverar spritdrycker, vin, starköl eller andra jästa alkoholdrycker mot betalning. Det gäller restauranger, barer, klubbar, festvåningar, cateringverksamhet och vid evenemang – oavsett om det är permanent eller tillfälligt.",
      },
      {
        q: "Vad innebär \"enstaka tillfälle\" i alkohollagen?",
        a: "Med enstaka tillfälle menas servering vid ett fåtal, oregelbundna tillfällen per år – t.ex. en bröllopsfest, företagsfest eller välgörenhetsgala. Då kan ett tillfälligt serveringstillstånd sökas i stället för ett stadigvarande. Kommunen avgör vad som räknas som enstaka i det enskilda fallet.",
      },
    ],
  },
  {
    title: "Krav och ansökan",
    items: [
      {
        q: "Hur många personer behöver ha kunskap för ett serveringstillstånd?",
        a: "Minst hälften av PBI-kretsen (personer med betydande inflytande) ska ha avlagt godkänt kunskapsprov i alkohollagen, och det ska alltid finnas minst en person med godkänt prov tillgänglig under serveringen. Kraven varierar något beroende på tillståndets typ – kontrollera alltid med kommunen.",
      },
      {
        q: "Vad kostar ett serveringstillstånd och hur länge gäller det?",
        a: "Avgiften sätts av varje kommun och varierar oftast mellan 4 000 och 14 000 kronor för ansökan. Ett stadigvarande serveringstillstånd gäller tills vidare så länge verksamheten uppfyller kraven. Därtill tillkommer en årlig tillsynsavgift.",
      },
      {
        q: "Hur svåra är frågorna på kunskapsprovet för serveringstillstånd?",
        a: "Provet är godkänt-eller-underkänt och kräver god kännedom om alkohollagen, serveringsbestämmelser, mat- och dryckeskunskap samt tillsyn. De flesta som förbereder sig med övningsfrågor klarar provet på första eller andra försöket. Med Alkoholprovet kan du träna på frågor i samma format som det skarpa provet.",
      },
      {
        q: "Vad betyder det att \"stå på\" ett serveringstillstånd?",
        a: "Att \"stå på\" ett serveringstillstånd betyder att vara en av de personer som är registrerad som tillståndshavare eller som PBI (person med betydande inflytande). Den som står på tillståndet ansvarar för att verksamheten följer alkohollagen.",
      },
    ],
  },
  {
    title: "Tillsyn och påföljder",
    items: [
      {
        q: "Vad händer om man bryter mot alkohollagen?",
        a: "Brott mot alkohollagen kan leda till erinran, varning, indraget serveringstillstånd eller åtal. Allvarliga överträdelser – som servering till minderåriga eller överservering – kan medföra böter eller fängelse i upp till två år enligt alkohollagen.",
      },
      {
        q: "Vad är Restaurangrapporten till Folkhälsomyndigheten?",
        a: "Restaurangrapporten är en årlig redovisning som alla med stadigvarande serveringstillstånd måste lämna in. Där rapporteras inköp och försäljning av alkohol. Rapporten lämnas via Folkhälsomyndighetens e-tjänst och är underlag för tillsyn och statistik.",
      },
      {
        q: "Vem beslutar om serveringstillstånd?",
        a: "Det är kommunen där verksamheten ligger som prövar och beslutar om serveringstillstånd. Beslutet fattas vanligtvis av kommunens socialnämnd, miljö- och tillståndsnämnd eller motsvarande, efter remiss från polisen, räddningstjänsten och Skatteverket.",
      },
      {
        q: "Vilka är tillsynsmyndigheterna för alkohollagen?",
        a: "Kommunen och polisen har gemensamt ansvar för tillsyn av serveringsställen. Länsstyrelsen utövar regional tillsyn över kommunernas arbete, och Folkhälsomyndigheten har den centrala tillsynen och tar fram föreskrifter på nationell nivå.",
      },
      {
        q: "Vad är åldersgränsen för att servera alkohol?",
        a: "Den som serverar alkohol på ett serveringsställe ska ha fyllt 20 år. Vid servering av folköl gäller 18 år. Tillståndshavaren ansvarar för att personalen uppfyller åldersgränserna.",
      },
    ],
  },
  {
    title: "Om Alkoholprovet",
    items: [
      { q: "Är Alkoholprovet officiellt?", a: "Nej. Alkoholprovet är ett fristående övningsverktyg och är inte kopplat till någon kommun eller myndighet." },
      { q: "Innehåller appen kommunens riktiga provfrågor?", a: "Nej. Frågorna är träningsfrågor och inte kommunens sekretessbelagda provfrågor. Innehållet är pedagogiskt utformat baserat på alkohollagen." },
      { q: "Hur fungerar betalningen?", a: "Du betalar säkert via Stripe med kort. Betalningen är en engångskostnad och tillgång aktiveras direkt." },
      { q: "Får jag kvitto?", a: "Ja, ett kvitto skickas automatiskt till din e-postadress efter köpet." },
      { q: "Hur länge har jag tillgång?", a: "10 dagar (199 kr inkl. moms), 30 dagar (349 kr inkl. moms) eller 90 dagar (599 kr inkl. moms). Tillgången upphör automatiskt – inget abonnemang att säga upp." },
      { q: "Är frågorna uppdaterade för 2026?", a: "Ja, vi arbetar löpande för att hålla innehållet aktuellt utifrån alkohollagen och nya regler 2026." },
      { q: "Kan jag använda appen i mobilen?", a: "Ja. Alkoholprovet är mobile-first och kan installeras som en webbapp (PWA) på din hemskärm." },
      { q: "Kan jag få pengarna tillbaka?", a: "Det är en digital tjänst – ångerrätten upphör när du fått tillgång. Vid tekniska problem eller fel, kontakta oss så hjälper vi dig." },
      { q: "Vad är skillnaden mot kommunens prov?", a: "Vårt material är ett övningsverktyg. Det faktiska provet genomförs hos kommunen och innehållet i deras prov är sekretessbelagt." },
      { q: "Behöver jag konto?", a: "Ja, du behöver ett konto för att spara din progress. Du kan komma igång gratis med 5 frågor per dag." },
    ],
  },
];

export const allFaqs = groups.flatMap((g) => g.items);

const FAQ = lazyRouteComponent(() => import("./faq.view"), "FAQ");

export const routeOptions = {
  component: FAQ,
  head: () => ({
    meta: [
      { title: "Vanliga frågor om serveringstillstånd – Alkoholprovet" },
      { name: "description", content: "Svar på vanliga frågor om serveringstillstånd, alkohollagen, kunskapsprovet, tillsyn och Alkoholprovet." },
      { property: "og:title", content: "Vanliga frågor om serveringstillstånd – Alkoholprovet" },
      { property: "og:description", content: "Vad krävs för serveringstillstånd? Vad kostar det? Vem beslutar? Få svar på de vanligaste frågorna om alkohollagen." },
      { property: "og:url", content: "https://alkoholprovet.se/faq" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/faq" }],
    scripts: [{
      type: "application/ld+json",
      children: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: allFaqs.map((f) => ({
          "@type": "Question",
          name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a },
        })),
      }),
    }],
  }),
};
